import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelCheckbox as _vModelCheckbox, createElementVNode as _createElementVNode, withDirectives as _withDirectives, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0f6904b0"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "app-switch__label"
}
const _hoisted_2 = { class: "app-switch-track" }
const _hoisted_3 = ["id", "disabled"]
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "app-switch-track__thumb" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("label", {
    class: _normalizeClass(["app-switch", { 'app-switch--disabled' : _ctx.disabled }])
  }, [
    (_ctx.label)
      ? (_openBlock(), _createElementBlock("span", _hoisted_1, _toDisplayString(_ctx.label), 1))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_2, [
      _withDirectives(_createElementVNode("input", {
        id: _ctx.id,
        type: "checkbox",
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.inputValue) = $event)),
        onChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('user-action:toggle'))),
        disabled: _ctx.disabled
      }, null, 40, _hoisted_3), [
        [_vModelCheckbox, _ctx.inputValue]
      ]),
      _hoisted_4
    ])
  ], 2))
}